import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AgencyDepartmentMenus } from 'src/app/shared/AgencyDepartmentMenus.model';
import { BaseService } from './Base.service';
@Injectable({
  providedIn: 'root'
})
export class AgencyDepartmentMenusService extends BaseService {
  constructor(public httpClient: HttpClient) {
    super(httpClient);
    this.Controller = "AgencyDepartmentMenus";
  }
}

